import React, { useState, useEffect, useRef } from "react";
import "./Sidebar.css";
import { ResizableBox } from "react-resizable";
import * as Icon from "react-feather";
import { Form, Collapse, Accordion } from "react-bootstrap";
import { toast } from "react-toastify";
import { isValidCron } from 'cron-validator';
import { RefreshCw as RefreshIcon } from "react-feather";
import { handleRefreshSerivce, updateDagService } from "../../../services/overview";
import { CircularProgress, Button } from "@mui/material"

const frequenciesOptions = [
  { value: "Hourly", label: "Hourly" },
  { value: "Daily", label: "Daily" },
  { value: "Custom", label: "Custom Cron" },
  { value: "Relative", label: "After another DAG" },
];

const AlertsOptions = [
  { value: "all", label: "When DAG starts and finishes (Success or Failure)" },
  { value: "only_finishes", label: "Only when DAG finishes (Success or Failure)" },
  { value: "only_failures", label: "Only when DAG fails" },
];

const DagEdit = ({ editing_dag_alias,advanced_settings,onClose,fetchDAGs, workflows,editorURL, dataWarehouses,queueOptions }) => {
  const [skips, setskips] = useState({});
  const [frequencies, setFrequencies] = useState("");
  const [cronExpression, setCronExpression] = useState(""); // New state for cron expression
  const [retries, setRetries] = useState(3);
  const [dagTimeout, setDagTimeout] = useState(60);
  const [alerts, setAlerts] = useState("");
  const [isFrequenciesMenuOpen, setFrequenciesMenuOpen] = useState(false);
  const [isAlertsMenuOpen, setAlertsMenuOpen] = useState(false);
  const [creatingDag, setCreatingDag] = useState(false);
  const [dbtCommand, setDbtCommand] = useState("");
  const [dbtExcludes, setDbtExcludes] = useState("");
  const [initialFrequencies, setInitialFrequencies] = useState("");
  const [initialCronExpression, setInitialCronExpression] = useState("");
  const [initialRetries, setInitialRetries] = useState(3);
  const [initialDagTimeout, setInitialDagTimeout] = useState(60);
  const [initialAlerts, setInitialAlerts] = useState("");
  const [initialSkips, setInitialSkips] = useState({});
  const [isDAGsListOpen, setIsDAGsListOpen] = useState(false);
  const alertsButtonRef = useRef(null);
  const alertsMenuRef = useRef(null);
  const [isRefreshing, setIsRefreshing] = useState(false);
  const [computeWarehouse, setComputeWarehouse] = useState(""); // State for selected compute warehouse
  const [isComputeDWHMenuOpen, setComputeDWHMenuOpen] = useState(false); // State for compute DWH dropdown visibility
  const [initialComputeWarehouse, setInitialComputeWarehouse] = useState(""); // State for initial compute warehouse
  const [queue, setQueue] = useState(""); // Add state for Queue dropdown
  const [isQueueMenuOpen, setIsQueueMenuOpen] = useState(false);
  const [initialQueue, setInitialQueue] = useState(""); // Add state for initial queue

  useEffect(() => {
    if (advanced_settings) {
      setRetries(advanced_settings.retries);
      setskips(advanced_settings.skips || {});
      setDagTimeout(advanced_settings.dag_timeout);
      setFrequencies(advanced_settings.schedule_frequency);
      setCronExpression(advanced_settings.schedule_details);
      setAlerts(advanced_settings.alerts);
      setDbtCommand(advanced_settings.dbt_command.join(" "));
      setDbtExcludes(advanced_settings.dbt_exclude?.join(" ") || "");      setComputeWarehouse(
        advanced_settings.compute_wh ||
        (dataWarehouses && dataWarehouses.length > 0 ? dataWarehouses[0].name : "")
      );
      setQueue(advanced_settings.queue || "Default"); // Set queue from fetched data, default if not present
  
      setInitialFrequencies(advanced_settings.schedule_frequency);
      setInitialCronExpression(advanced_settings.schedule_details);
      setInitialRetries(advanced_settings.retries);
      setInitialDagTimeout(advanced_settings.dag_timeout);
      setInitialAlerts(advanced_settings.alerts);
      setInitialSkips(advanced_settings.skips);
      setInitialComputeWarehouse(
        advanced_settings.compute_wh ||
        (dataWarehouses && dataWarehouses.length > 0 ? dataWarehouses[0].name : "")
      );
      setInitialQueue(advanced_settings.queue || "Default"); // Set queue from fetched data, default if not present
    }
  }, [advanced_settings]);

  const handleFrequenciesToggle = (e) => {
    if (e) e.stopPropagation();
    
    setAlertsMenuOpen(false);
    setComputeDWHMenuOpen(false);
    setIsQueueMenuOpen(false);
    setIsDAGsListOpen(false);
    
    setFrequenciesMenuOpen(!isFrequenciesMenuOpen);
  };

  const selectAlerts = (val) => {
    setAlerts(val);
    handleAlertsToggle();
  };

  const handleAlertsToggle = (e) => {
    if (e) e.stopPropagation();
    
    setFrequenciesMenuOpen(false);
    setComputeDWHMenuOpen(false);
    setIsQueueMenuOpen(false);
    setIsDAGsListOpen(false);
    
    setAlertsMenuOpen(!isAlertsMenuOpen);
  };

  const selectFrequencies = (val) => {
    setFrequencies(val);
    handleFrequenciesToggle();
    setCronExpression("");
  };

  const renderAlertsOptions = () =>
    AlertsOptions.map((alertsOption) => (
      <li
        key={alertsOption.value}
        onClick={() => selectAlerts(alertsOption.value)}
        className="schedule-menu-item"
      >
        {alertsOption.label}
      </li>
    ));

  const renderFrequenciesOptions = () =>
    frequenciesOptions.map((frequenciesOption) => (
      <li
        key={frequenciesOption.value}
        onClick={() => selectFrequencies(frequenciesOption.value)}
        className="schedule-menu-item"
      >
        {frequenciesOption.label}
      </li>
    ));

  const handleComputeDWHMenuToggle = (e) => {
    e.stopPropagation();
    setComputeDWHMenuOpen(!isComputeDWHMenuOpen);
  };

  const selectComputeDWH = (e, wh) => {
    setComputeWarehouse(wh);
    handleComputeDWHMenuToggle(e);
  };

  const handleQueueMenuToggle = (e) => {
    e.stopPropagation();
    setIsQueueMenuOpen(!isQueueMenuOpen);
  };

  const selectQueue = (e, q) => {
    setQueue(q);
    handleQueueMenuToggle(e);
  };

  const renderComputeDWHOptions = () => {
    if (!dataWarehouses || dataWarehouses.length === 0) {
      return <li className="schedule-menu-item disabled">Loading warehouses...</li>;
    }
    return dataWarehouses.map((wh) => (
      <li
        key={wh.name  }
        onClick={(e) => selectComputeDWH(e, wh.name)}
        className="schedule-menu-item"
        style={{
          padding: '5px 15px'
        }}
      >
        {wh.name}
      </li>
    ));
  };

  const renderQueueOptions = () => {
    return queueOptions.map((q) => (
      <li
        key={q.name}
        onClick={(e) => selectQueue(e, q.name)}
        className={`schedule-menu-item ${queue === q.name ? 'selected' : ''}`}
        style={{
          padding: '5px 15px'
        }}
      >
        {q.name}
      </li>
    ));
  };

  const updateDAG = async () => {
    if (!frequencies) {
      toast.info("Please provide the schedule frequency");
      return;
    }
    else if (frequencies === "Custom" && !isValidCron(cronExpression, { alias: true, seconds: true })) {
      toast.info("Invalid cron expression");
      return;
    }

    else if (frequencies === "Hourly" && !cronExpression) {
      toast.info("Please input the minute you want your DAG to run at every hour");
      return;
    } else if (frequencies === "Hourly" && cronExpression) {
      const minute = parseInt(cronExpression, 10);
      if (isNaN(minute) || minute < 0 || minute > 59) {
        toast.error("Please input a valid minute (0-59) for hourly DAG run");
        return;
      }
    }
    
    else if (frequencies === "Daily" && !cronExpression) {
      toast.info("Please input the hour you want your DAG to run at every day");
      return;
    } else if (frequencies === "Daily" && cronExpression) {
      const hour = parseInt(cronExpression, 10);
      if (isNaN(hour) || hour < 0 || hour > 23) {
        toast.error("Please input a valid hour (0-23) for daily DAG run");
        return;
      }
    }

    else if (frequencies === "Relative" && !cronExpression) {
        toast.info("Please select a relative DAG");
        return;
      }

    if (
      frequencies === initialFrequencies &&
      cronExpression === initialCronExpression &&
      retries === initialRetries &&
      dagTimeout === initialDagTimeout &&
      alerts === initialAlerts &&
      skips === initialSkips &&
      computeWarehouse === initialComputeWarehouse &&
      queue === initialQueue
    ) {
      toast.info("No changes detected to your DAG.");
      return;
    }
    setCreatingDag(true);

    const isSuccess = await updateDagService({
      dag_alias: editing_dag_alias,
      schedule_frequency: frequencies,
      cron_expression: cronExpression,
      dag_timeout: dagTimeout,
      retries: retries,
      alerts: alerts,
      skips: skips,
      compute_wh: computeWarehouse,
      queue: queue
    });

    if(isSuccess) {
      fetchDAGs(true);
      onClose();
    }

    setCreatingDag(false);
  };

  useEffect(() => {
    const handleScroll = () => {
      if (isAlertsMenuOpen && alertsButtonRef.current && alertsMenuRef.current) {
        const buttonRect = alertsButtonRef.current.getBoundingClientRect();
        alertsMenuRef.current.style.top = `${buttonRect.bottom + window.scrollY}px`;
        alertsMenuRef.current.style.left = `${buttonRect.left + window.scrollX}px`;
      }
    };

    window.addEventListener("scroll", handleScroll);
    window.addEventListener("click", () => { // Add click listener to close Compute DWH dropdown
      setFrequenciesMenuOpen(false);
      setAlertsMenuOpen(false);
      setComputeDWHMenuOpen(false); // Close compute DWH dropdown on outside click
      setIsQueueMenuOpen(false); // Close queue dropdown on outside click
    });
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [isAlertsMenuOpen, isComputeDWHMenuOpen, isQueueMenuOpen]); // Add isComputeDWHMenuOpen dependency

  const handleDAGsListToggle = (e) => {
    if (e) e.stopPropagation();
    
    // Close all other dropdowns first
    setFrequenciesMenuOpen(false);
    setAlertsMenuOpen(false);
    setComputeDWHMenuOpen(false);
    setIsQueueMenuOpen(false);
    
    // Toggle the DAGs list
    setIsDAGsListOpen(!isDAGsListOpen);
  };

  const selectWorkflow = (DAG, e) => {
    if (e) e.stopPropagation();
    setCronExpression(DAG);
    setIsDAGsListOpen(false);
  }
  const handleRefresh = async () => {
    setIsRefreshing(true);
    
    const isSuccess = await handleRefreshSerivce(editorURL, advanced_settings);

    if(isSuccess) {
      fetchDAGs(true, true);
    }

    setTimeout(() => {
      setIsRefreshing(false);
    }, 2000);
  };

  return (
    <ResizableBox
      className={`dragged-box react-resizable sidebar-modal-wrapper`}
      height={window.innerHeight - 50}
      width={window.innerWidth / 3}
      maxConstraints={[window.innerWidth - 65, window.innerHeight - 50]}
      minConstraints={[400, 400]}
      resizeHandles={["w"]}
      id="active-modal-sidebar"
    >
      <section className="schedule-sidebar-content">
        <div style={{ marginBottom: '12px', position: 'relative' }}>
        <div style={{
            display: 'inline-flex',
            alignItems: 'center',
            padding: '10px',
            borderRadius: '10px',
            background: 'rgba(85, 110, 230, 0.08)',
            color: '#556ee6',
            fontWeight: '600',
            fontSize: '13px',
            letterSpacing: '0.2px',
            boxShadow: '0 2px 6px rgba(85, 110, 230, 0.1)',
            border: '2px solid rgba(19, 25, 59, 0.15)',
            position: 'relative',
            paddingRight: '45px',
            width: '100%'
          }}>
            <Icon.ChevronsRight
              color="#556ee6"
              onClick={onClose}
              role="button"
              style={{ marginRight: '8px', cursor: 'pointer' }}
              size={16}
            />
            <span>Edit DAG</span>
            <span style={{
              position: 'absolute',
              right: '10px',
              top: '50%',
              transform: 'translateY(-50%)',
              padding: '2px 6px',
              display: 'flex',
              alignItems: 'center'
            }}>
              <Icon.Edit3
                color="#556ee6"
                size={14}
              />
            </span>
          </div>
        </div>
        <Form>
          <Accordion defaultActiveKey="1" className="pl-0 modern-accordion mb-3">
            <Accordion.Item
              eventKey="1"
              className="bg-white"
              style={{
                borderRadius: '18px',
                background: 'linear-gradient(to bottom, #fff, #f9fbfe)',
                boxShadow: '0 8px 20px rgba(85, 110, 230, 0.1), 0 2px 8px rgba(0, 0, 0, 0.05)',
                overflow: 'hidden',
                border: 'none',
                transition: 'all 0.05s ease-in-out'
              }}
            >
              <Accordion.Body 
                className="animate__animated animate__fadeIn" 
                style={{ 
                  padding: '18px 25px 22px',
                  backgroundColor: 'rgba(85, 110, 230, 0.03)',
                  borderTop: '1px solid rgba(85, 110, 230, 0.05)',
                  borderRadius: '0 0 18px 18px',
                  transition: 'all 0.3s ease-in-out'
                }}
              >
                <Form.Group controlId="modelName" className="mb-3">
                  <Form.Label 
                    style={{ 
                      fontSize: '11px', 
                      fontWeight: '500', 
                      color: '#495057',
                    }}
                  >
                    DAG alias
                  </Form.Label>
                  <Form.Control
                    value={editing_dag_alias}
                    type="text"
                    placeholder="Enter DAG alias"
                    disabled
                    style={{ fontSize: "11px" }}
                  />
                </Form.Group>
                <Form.Group controlId="dbtCommand" className="mb-3">
                  <Form.Label 
                    style={{ 
                      fontSize: '11px', 
                      fontWeight: '500', 
                      color: '#495057',
                    }}
                  >
                    Selected Nodes
                  </Form.Label>
                  <Form.Control
                    value={dbtCommand}
                    type="text"
                    disabled
                    style={{ fontSize: "11px" }}
                  />
                </Form.Group>
                <Form.Group controlId="dbtCommand" className="mb-3">
                  <Form.Label 
                    style={{ 
                      fontSize: '11px', 
                      fontWeight: '500', 
                      color: '#495057',
                    }}
                  >
                    Excluded Nodes
                  </Form.Label>
                  <Form.Control
                    value={dbtExcludes}
                    type="text"
                    disabled
                    style={{ fontSize: "11px" }}
                  />
                </Form.Group>

                <Form.Group controlId="schedule_freq">
                  <Form.Label 
                    style={{ 
                      fontSize: '11px', 
                      fontWeight: '500', 
                      color: '#495057',
                    }}
                  >
                    Schedule Frequency
                  </Form.Label>
                  <div style={{ position: 'relative', display: 'flex', gap: '10px' }}>
                    <div style={{flex: 1, position: "relative"}}>
                      <Button
                        onClick={(e) => handleFrequenciesToggle(e)}
                        aria-controls="schedule-collapse-frequencies"
                        aria-expanded={isFrequenciesMenuOpen}
                        sx={{ 
                          width: "100%",
                          flex: 1,
                          justifyContent: 'space-between',
                          fontSize: "11px",
                          bgcolor: "#fff",
                          color: frequencies ? "#495057" : "grey",
                          border: "1px solid #ebebeb",
                          marginBottom: "15px",
                          height: "36px",

                          "&:hover": {
                            bgcolor: "#ebebeb",
                            color: "#000",
                            borderColor: "#3266bb"
                          }
                        }}
                      >
                        <span>{frequencies
                          ? frequenciesOptions.find((opt) => opt.value === frequencies).label
                          : "Select schedule"}</span>
                        <Icon.ChevronDown size={16} style={{ opacity: 0.5, marginLeft: '8px' }}/>
                      </Button>
                      <Collapse in={isFrequenciesMenuOpen}>
                        <ul id="schedule-collapse-frequencies" className="schedule-menu">
                          {renderFrequenciesOptions()}
                        </ul>
                      </Collapse>
                    </div>
                    {frequencies === "Relative" ? (
                      <div style={{ flex: 1, position: "relative", maxWidth: "calc(50% - 5px)" }}>
                        <Button
                          onClick={(e) => handleDAGsListToggle(e)}
                          aria-controls="schedule-collapse-dags"
                          aria-expanded={isDAGsListOpen}
                          sx={{ 
                            width: "100%",
                            flex: 1,
                            justifyContent: 'space-between',
                            fontSize: "11px",
                            bgcolor: "#fff",
                            color: cronExpression ? "#495057" : "grey",
                            border: "1px solid #ebebeb",
                            marginBottom: "15px",
                            height: "36px",
                            whiteSpace: "nowrap",
                            overflow: "hidden",
  
                            "&:hover": {
                              bgcolor: "#ebebeb",
                              color: "#000",
                              borderColor: "#3266bb"
                            }
                          }}
                        >
                          <span>{cronExpression && workflows
                            ? workflows.find((workflow) => workflow.dag_id === cronExpression)?.workflowname ?? "Select DAG"
                            : "Select DAG"}</span>
                          <Icon.ChevronDown size={16} style={{ opacity: 0.5, marginLeft: '8px' }}/>
                        </Button>
                        <Collapse in={isDAGsListOpen}>
                          <ul id="schedule-collapse-dags" className="schedule-menu">
                            {workflows
                              .filter(workflow => workflow.workflowname !== editing_dag_alias)
                              .map(workflow => (
                                <li
                                  key={workflow.dag_id}
                                  onClick={(e) => selectWorkflow(workflow.dag_id, e)}
                                  className="schedule-menu-item"
                                >
                                  {workflow.workflowname}
                                </li>
                              )
                            )}
                          </ul>
                        </Collapse>
                      </div>
                    ) : (
                      <Form.Control
                        type="text"
                        value={cronExpression}
                        onChange={(e) => setCronExpression(e.target.value)}
                        placeholder= {frequencies === "Custom" ? "Enter cron expression" :  frequencies === "Hourly" ? "Minute to run at" : "Hour to run at"}
                        className={`collapse-schedule ${
                          frequencies && "collapse-schedule-chosen"
                        }`}  
                        style={{ flex: 1, fontSize: "11px" }}
                      />
                    )}
                  </div>
                </Form.Group>
                <Form.Group controlId="alerts">
                  <Form.Label 
                    style={{ 
                      fontSize: '11px', 
                      fontWeight: '500', 
                      color: '#495057',
                    }}
                  >
                    Slack Alert
                  </Form.Label>
                  <div style={{ position: 'relative' }}>
                    <Button
                      ref={alertsButtonRef}
                      onClick={(e) => handleAlertsToggle(e)}
                      aria-controls="schedule-collapse-alerts"
                      aria-expanded={isAlertsMenuOpen}
                      sx={{ 
                        width: "100%",
                        flex: 1,
                        justifyContent: 'space-between',
                        fontSize: "11px",
                        bgcolor: "#fff",
                        color: alerts ? "#495057" : "grey",
                        border: "1px solid #ebebeb",
                        marginBottom: "15px",
                        height: "36px",
  
                        "&:hover": {
                          bgcolor: "#ebebeb",
                          color: "#000",
                          borderColor: "#3266bb"
                        }
                      }}
                    >
                      <span style={{fontSize: "11px", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", maxWidth: "calc(100% - 20px)"}}>{alerts
                        ? AlertsOptions.find((opt) => opt.value === alerts).label
                        : "Should we tell you when your DAG starts, succeeds or fails?"}</span>
                      <Icon.ChevronDown size={16} style={{ opacity: 0.5, marginLeft: '8px' }}/>
                    </Button>
                    <Collapse in={isAlertsMenuOpen}>
                      <ul
                        id="schedule-collapse-alerts"
                        className="schedule-menu"
                        ref={alertsMenuRef}
                      >
                        {renderAlertsOptions()}
                      </ul>
                    </Collapse>
                  </div>
                </Form.Group>
              </Accordion.Body>
            </Accordion.Item>
          </Accordion>
          
          <Accordion defaultActiveKey="1" className="pl-0 modern-accordion">
            <Accordion.Item
              eventKey="0"
              className="bg-white"
              style={{
                borderRadius: '18px',
                background: 'linear-gradient(to bottom, #fff, #f9fbfe)',
                boxShadow: '0 8px 20px rgba(85, 110, 230, 0.1), 0 2px 8px rgba(0, 0, 0, 0.05)',
                overflow: 'hidden',
                border: 'none',
                transition: 'all 0.05s ease-in-out'
              }}
            >
              <Accordion.Header
                style={{
                  background: 'transparent',
                  border: 'none',
                  width: '100%',
                  borderRadius: '18px 18px 0 0',
                  transition: 'all 0.3s ease'
                }}
              >
                <div 
                  className="d-flex align-items-center w-100" 
                  style={{ 
                    fontWeight: '600', 
                    fontSize: '12px', 
                    color: '#556ee6',
                    letterSpacing: '0.2px'
                  }}
                >
                  <div 
                    style={{
                      backgroundColor: 'rgba(85, 110, 230, 0.1)',
                      borderRadius: '50%',
                      width: '32px',
                      height: '32px',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      marginRight: '12px'
                    }}
                  >
                    <Icon.Settings size={16} color="#556ee6" />
                  </div>
                  Advanced Settings
                  <span 
                    className="ms-auto" 
                    style={{
                      transform: 'translateY(-1px)',
                      opacity: 0.7,
                      fontWeight: 'normal',
                      fontSize: '12px'
                    }}
                  >
                  </span>
                </div>
              </Accordion.Header>
              <Accordion.Body 
                className="animate__animated animate__fadeIn" 
                style={{ 
                  padding: '18px 25px 22px',
                  backgroundColor: 'rgba(85, 110, 230, 0.03)',
                  borderTop: '1px solid rgba(85, 110, 230, 0.05)',
                  borderRadius: '0 0 18px 18px',
                  transition: 'all 0.3s ease-in-out'
                }}
              >
                <div className="d-flex gap-3">
                  <Form.Group controlId="compute_dwh" style={{ flex: 1 }}>
                    <Form.Label 
                      style={{ 
                        fontSize: '11px', 
                        fontWeight: '500', 
                        color: '#495057',
                        marginBottom: '8px'
                      }}
                    >
                      Compute DWH
                    </Form.Label>
                    <div style={{ position: "relative" }}>
                      <Button
                        onClick={handleComputeDWHMenuToggle}
                        aria-controls="schedule-collapse-compute-dwh"
                        aria-expanded={isComputeDWHMenuOpen}
                        sx={{ 
                          width: "100%",
                          flex: 1,
                          justifyContent: 'space-between',
                          fontSize: "11px",
                          bgcolor: "#fff",
                          color: computeWarehouse ? "#495057" : "grey",
                          marginBottom: "15px",
                          height: "36px",
                          borderRadius: '10px',
                          boxShadow: '0 2px 4px rgba(0,0,0,0.04)',
                          transition: 'all 0.2s ease',
                          border: '1px solid rgba(0,0,0,0.08)',
                          padding: '8px 15px',
                          whiteSpace: "nowrap",
                          overflow: "hidden",

                          "&:hover": {
                            bgcolor: "#ebebeb",
                            color: "#000",
                          }
                        }}
                      >
                        <span>{computeWarehouse || "Select Compute DWH"}</span>
                        <Icon.ChevronDown size={16} style={{ opacity: 0.5, marginLeft: '8px' }}/>
                      </Button>
                      <Collapse in={isComputeDWHMenuOpen}>
                        <ul
                          id="schedule-collapse-compute-dwh"
                          className="schedule-menu modern-dropdown-menu"
                          style={{
                            borderRadius: '5px',
                            boxShadow: '0 6px 16px rgba(0,0,0,0.1)',
                            border: '1px solid rgba(0,0,0,0.05)',
                            padding: '6px 0',
                            marginTop: '3px',
                            maxHeight: '200px',
                            overflowY: 'auto'
                          }}
                        >
                          {renderComputeDWHOptions()}
                        </ul>
                      </Collapse>
                    </div>
                  </Form.Group>
                  <Form.Group controlId="queue" style={{ flex: 1 }}>
                    <Form.Label 
                      style={{ 
                        fontSize: '11px', 
                        fontWeight: '500', 
                        color: '#495057',
                        marginBottom: '8px'
                      }}
                    >
                      Worker Queue
                    </Form.Label>
                    <div style={{ position: "relative" }}>
                      <Button
                        onClick={handleQueueMenuToggle}
                        aria-controls="schedule-collapse-queue"
                        aria-expanded={isQueueMenuOpen}
                        sx={{ 
                          width: "100%",
                          flex: 1,
                          justifyContent: 'space-between',
                          fontSize: "11px",
                          bgcolor: "#fff",
                          color: queue ? "#495057" : "grey",
                          marginBottom: "15px",
                          height: "36px",
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          borderRadius: '10px',
                          boxShadow: '0 2px 4px rgba(0,0,0,0.04)',
                          transition: 'all 0.2s ease',
                          border: '1px solid rgba(0,0,0,0.08)',
                          padding: '8px 15px',

                          "&:hover": {
                            bgcolor: "#ebebeb",
                            color: "#000",
                          }
                        }}
                      >
                        <span>{queue || "Select Queue"}</span>
                        <Icon.ChevronDown size={16} style={{ opacity: 0.5, marginLeft: '8px' }}/>
                      </Button>
                      <Collapse in={isQueueMenuOpen}>
                        <ul
                          id="schedule-collapse-queue"
                          className="schedule-menu modern-dropdown-menu"
                          style={{
                            borderRadius: '12px',
                            boxShadow: '0 6px 16px rgba(0,0,0,0.1)',
                            border: '1px solid rgba(0,0,0,0.05)',
                            padding: '6px 0',
                            marginTop: '6px',
                            maxHeight: '200px',
                            overflowY: 'auto'
                          }}
                        >
                          {renderQueueOptions()}
                        </ul>
                      </Collapse>
                    </div>
                  </Form.Group>
                </div>
                <div className="d-flex gap-3 mb-4">
                  <Form.Group controlId="dag_timeout" style={{ flex: 1 }}>
                    <Form.Label 
                      style={{ 
                        fontSize: '11px', 
                        fontWeight: '500', 
                        color: '#495057',
                        marginBottom: '8px'
                      }}
                    >
                      DAG Timeout (in minutes)
                    </Form.Label>
                    <Form.Control
                      type="number"
                      value={dagTimeout}
                      onChange={(e) => setDagTimeout(e.target.value)}
                      placeholder="60"
                      style={{
                        padding: '8px 15px',
                        borderRadius: '10px',
                        border: '1px solid rgba(0,0,0,0.08)',
                        boxShadow: '0 2px 4px rgba(0,0,0,0.04)',
                        transition: 'all 0.2s ease',
                        fontSize: "11px"
                      }}
                    />
                  </Form.Group>
                  <Form.Group controlId="retries" style={{ flex: 1 }}>
                    <Form.Label 
                      style={{ 
                        fontSize: '11px', 
                        fontWeight: '500', 
                        color: '#495057',
                        marginBottom: '8px'
                      }}
                    >
                      Retries
                    </Form.Label>
                    <Form.Control
                      type="number"
                      value={retries}
                      onChange={(e) => setRetries(e.target.value)}
                      placeholder="3"
                      style={{
                        padding: '8px 15px',
                        borderRadius: '10px',
                        border: '1px solid rgba(0,0,0,0.08)',
                        boxShadow: '0 2px 4px rgba(0,0,0,0.04)',
                        transition: 'all 0.2s ease',
                        fontSize: "11px"
                      }}
                    />
                  </Form.Group>
                </div>
                <Form.Group controlId="sources" className="mb-3">
                  <div className="d-flex justify-content-between align-items-center mb-3">
                    <Form.Label 
                      className="mb-0"
                      style={{ 
                        fontSize: '11px', 
                        fontWeight: '500', 
                        color: '#495057'
                      }}
                    >
                      Skip Sources (in minutes)<br/>
                      <span 
                        style={{ 
                          fontWeight: '400', 
                          opacity: 0.7, 
                          fontSize: '10px'
                        }}
                      >
                        0 minutes default means never skip
                      </span>
                    </Form.Label>
                    {isRefreshing ? (
                      <CircularProgress size={16} color="#556ee6" sx={{mt: "3px"}} />
                    ) : (
                      <Button
                        variant="contained"
                        size="small"
                        sx={{
                          backgroundColor: 'rgba(85, 110, 230, 0.1)',
                          borderRadius: '50%',
                          width: '28px',
                          height: '28px',
                          minWidth: 0,
                          transition: 'all 0.2s ease'
                        }}
                        onClick={handleRefresh}
                      >
                        <RefreshIcon size={14} color="#556ee6" />
                      </Button>
                    )}
                  </div>
                  {isRefreshing ? (
                    <div 
                      style={{
                        padding: '12px',
                        borderRadius: '10px',
                        backgroundColor: 'rgba(85, 110, 230, 0.05)',
                        textAlign: 'center',
                        fontSize: '13px',
                        color: '#556ee6'
                      }}
                    >
                      Identifying sources, please wait...
                    </div>
                  ) : Object.keys(skips).length > 0 ? (
                    <div 
                      style={{
                        borderRadius: '10px',
                        backgroundColor: 'rgba(255, 255, 255, 0.5)',
                        padding: '10px',
                        boxShadow: '0 2px 6px rgba(0,0,0,0.03)'
                      }}
                    >
                      {Object.keys(skips).map((sourceName) => (
                        <div key={sourceName} className="d-flex mb-2 align-items-center">
                          <div 
                            style={{ 
                              width: '60%', 
                              paddingRight: '15px',
                              fontSize: '13px'
                            }}
                          >
                            <span 
                              style={{
                                display: 'inline-block',
                                whiteSpace: 'nowrap',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                width: '100%',
                                padding: '8px 10px',
                                backgroundColor: 'rgba(85, 110, 230, 0.05)',
                                borderRadius: '8px',
                                color: '#495057'
                              }}
                            >
                              {sourceName}
                            </span>
                          </div>
                          <Form.Control
                            type="number"
                            value={skips[sourceName]}
                            onChange={(e) => {
                              const updatedSkips = { ...skips };
                              updatedSkips[sourceName] = e.target.value === '' ? '' : parseInt(e.target.value, 10);
                              setskips(updatedSkips);
                            }}
                            style={{ 
                              width: '40%', 
                              padding: '8px 15px',
                              borderRadius: '8px',
                              border: '1px solid rgba(0,0,0,0.08)',
                              boxShadow: 'none'
                            }}
                          />
                        </div>
                      ))}
                    </div>
                  ) : (
                    <div 
                      style={{
                        padding: '12px',
                        borderRadius: '10px',
                        backgroundColor: 'rgba(85, 110, 230, 0.05)',
                        textAlign: 'center',
                        fontSize: '13px',
                        color: '#556ee6'
                      }}
                    >
                      No source identified
                    </div>
                  )}
                </Form.Group>
              </Accordion.Body>
            </Accordion.Item>
          </Accordion>
        </Form>
        <div className="d-flex justify-content-between gap-2 mt-auto schedule-model-btns-wrapper">
          <Button
            className="w-100 sc-btn"
            disabled={creatingDag}
            onClick={updateDAG}
            sx={{
              width: "100%",
              backgroundColor: "#54cb75",
              border: "none",
              padding: "12px 16px",
              color: "#fff",

              "&:hover": {
                bgcolor: "#54cb75",
                opacity: 0.8
              },

              "&:disabled": {
                bgcolor: "#54cb75",
                color: "#fff"
              }
            }}
          >
            <div style={{ 
              display: "flex", 
              justifyContent: "center", 
              alignItems: "center", 
              width: "100%",
              position: "relative"
            }}>
              <span style={{ 
                fontWeight: "700", 
                letterSpacing: "0.3px", 
                fontSize: "12px",
                textAlign: "center"
              }}>
                Edit my DAG
              </span>
              <div style={{ 
                display: "flex", 
                alignItems: "center", 
                justifyContent: "center",
                backgroundColor: "rgba(255, 255, 255, 0.2)",
                borderRadius: "50%",
                padding: "5px",
                height: "24px",
                width: "24px",
                position: "absolute",
                right: "0"
              }}>
                <svg 
                  stroke="currentColor" 
                  fill="currentColor" 
                  strokeWidth="0" 
                  viewBox="0 0 512 512" 
                  height="0.9em" 
                  width="0.9em" 
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path d="M505.12019,19.09375c-1.18945-5.53125-6.65819-11-12.207-12.1875C460.716,0,435.507,0,410.40747,0,307.17523,0,245.26909,55.20312,199.05238,128H94.83772c-16.34763.01562-35.55658,11.875-42.88664,26.48438L2.51562,253.29688A28.4,28.4,0,0,0,0,264a24.00867,24.00867,0,0,0,24.00582,24H127.81618l-22.47457,22.46875c-11.36521,11.36133-12.99607,32.25781,0,45.25L156.24582,406.625c11.15623,11.1875,32.15619,13.15625,45.27726,0l22.47457-22.46875V488a24.00867,24.00867,0,0,0,24.00581,24,28.55934,28.55934,0,0,0,10.707-2.51562l98.72834-49.39063c14.62888-7.29687,26.50776-26.5,26.50776-42.85937V312.79688c72.59753-46.3125,128.03493-108.40626,128.03493-211.09376C512.07526,76.5,512.07526,51.29688,505.12019,19.09375ZM384.04033,168A40,40,0,1,1,424.05,128,40.02322,40.02322,0,0,1,384.04033,168Z"></path>
                </svg>
              </div>
            </div>
          </Button>
        </div>
      </section>
    </ResizableBox>
  );
};

export default DagEdit;